import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import './Navbar.css';

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <motion.nav
      className={`navbar ${scrolled ? 'navbar--scrolled' : ''}`}
      initial={{ y: -80, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.7, ease: 'easeOut' }}
    >
      <div className="navbar__inner">
        <a href="/" className="navbar__logo">
          <img src="/bayesmech_logo.png" alt="BayesMech Logo" className="navbar__logo-icon" style={{ width: '40px', height: '40px', objectFit: 'contain', fontSize: 0 }} />
          <span className="navbar__logo-text">BayesMech</span>
        </a>

        <ul className="navbar__links">
          <li><a href="#product">Product</a></li>
          <li><a href="#vision">Vision</a></li>
          <li><a href="#team">Team</a></li>
          <li><a href="/blog">Blog</a></li>
        </ul>

        <div className="navbar__actions">
          <a href="#build" className="navbar__cta">
            Help us Build
          </a>
        </div>
      </div>
    </motion.nav>
  );
}
